export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q03_a.ff35a59f.png";